export enum ScenariosPageType {
  Assigned = "assigned",
  Personal = "personal",
  All = "all",
}
